module.exports = __webpack_public_path__ + "img/icon.dd9b2da2.png";